import { all, call, put, takeLatest } from 'redux-saga/effects';
import Api from '../../services/Api';
import { supports, wording } from '../../util/context';
import { loadingError } from '../../util/error';
import { translate as _ } from '../../util/i18n';
import { showMessage } from '../../util/ui';
import {
    ADD_PLAYERS_TO_ROSTER,
    ADDING_PLAYERS_TO_ROSTER_FAILED,
    ADDING_PLAYERS_TO_ROSTER_SUCCEEDED,
    CONFIRM_GAME_REPORT_REFEREE,
    CONFIRMING_GAME_REPORT_REFEREE_FAILED,
    CONFIRMING_GAME_REPORT_REFEREE_SUCCEEDED,
    CONFIRM_ROSTER_PLAYERS,
    CONFIRMING_ROSTER_PLAYERS_FAILED,
    CONFIRMING_ROSTER_PLAYERS_SUCCEEDED,
    EDIT_ROSTER_PLAYER,
    EDIT_ROSTER_PLAYERS,
    EDITING_ROSTER_PLAYER_FAILED,
    EDITING_ROSTER_PLAYERS_FAILED,
    EDITING_ROSTER_PLAYER_SUCCEEDED,
    EDITING_ROSTER_PLAYERS_SUCCEEDED,
    ELIGIBLE_PLAYERS_REQUESTED,
    ELIGIBLE_TEAM_OFFICIALS_REQUESTED,
    EXTENDED_ELIGIBLE_PLAYERS_REQUESTED,
    EXTENDED_ELIGIBLE_TEAM_OFFICIALS_REQUESTED,
    GAME_REPORT_REFEREE_REQUESTED,
    GAMES_REQUESTED,
    IS_LOADING,
    LOADING_GAME_REPORT_REFEREE_SUCCEEDED,
    LOADING_GAME_REPORT_REFEREE_FAILED,
    LOADING_GAMES_FAILED,
    LOADING_GAMES_SUCCEEDED,
    LOADING_ELIGIBLE_PLAYERS_FAILED,
    LOADING_ELIGIBLE_PLAYERS_SUCCEEDED,
    LOADING_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED,
    LOADING_ELIGIBLE_TEAM_OFFICIALS_FAILED,
    LOADING_EXTENDED_ELIGIBLE_PLAYERS_FAILED,
    LOADING_EXTENDED_ELIGIBLE_PLAYERS_SUCCEEDED,
    LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED,
    LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_FAILED,
    LOADING_REFEREES_SUCCEEDED,
    LOADING_REFEREES_FAILED,
    LOADING_ROSTERS_FAILED,
    LOADING_ROSTERS_SUCCEEDED,
    LOADING_SCORES_FAILED,
    LOADING_SCORES_SUCCEEDED,
    LOADING_SEASONS_FAILED,
    LOADING_SEASONS_SUCCEEDED,
    OVERWRITE_GAME_REPORT_REFEREE,
    OVERWRITING_GAME_REPORT_REFEREE_FAILED,
    OVERWRITING_GAME_REPORT_REFEREE_SUCCEEDED,
    PUBLISH_ROSTER,
    PUBLISHING_ROSTER_FAILED,
    PUBLISHING_ROSTER_SUCCEEDED,
    REFEREES_REQUESTED,
    REMOVE_ROSTER_PLAYER,
    REMOVING_ROSTER_PLAYER_FAILED,
    REMOVING_ROSTER_PLAYER_SUCCEEDED,
    ROSTERS_REQUESTED,
    SAVE_GAME_REPORT_REFEREE_DRAFT,
    SAVING_GAME_REPORT_REFEREE_DRAFT_FAILED,
    SAVING_GAME_REPORT_REFEREE_DRAFT_SUCCEEDED,
    SCORES_REQUESTED,
    SEASONS_REQUESTED,
    SET_ROSTER_STATUS,
    SETTING_ROSTER_STATUS_FAILED,
    SETTING_ROSTER_STATUS_SUCCEEDED,
    SIGN_GAME_REPORT_REFEREE,
    SIGN_SUPPLEMENTARY,
    SIGNING_GAME_REPORT_REFEREE_FAILED,
    SIGNING_GAME_REPORT_REFEREE_SUCCEEDED,
    SIGNING_SUPPLEMENTARY_FAILED,
    SIGNING_SUPPLEMENTARY_SUCCEEDED,
    TAKE_FACE_CHECK,
    TAKING_FACE_CHECK_FAILED,
    TAKING_FACE_CHECK_SUCCEEDED
} from '../constants/actionTypes';

function* addPlayersToRoster( action ) {

    // action.payload.players.length
    // action.payload.teamOfficials.length

    const err = _( wording( action.payload.context, 'lineup' ) ? 'Auswahl konnte nicht zur Aufstellung hinzugefügt werden.' : 'Auswahl konnte nicht zum Roster hinzugefügt werden.' );

    try {

        const response = yield call( Api.addPlayersToRoster, action.payload );

        if ( response.statusId > 0 ) {

            const added   = [];

            action.payload.players.length && added.push( action.payload.players.length + ' ' + ( action.payload.players.length === 1 ? _( 'Spieler', 'singular' ) : _( 'Spieler', 'plural' ) ) );

            supports( action.payload.context, 'teamOfficials' ) && action.payload.teamOfficials.length && added.push( action.payload.teamOfficials.length + ' ' + _( action.payload.teamOfficials.length === 1 ? 'Team-Offizieller' : 'Team-Offizielle' ) );

            yield put( { type: ADDING_PLAYERS_TO_ROSTER_SUCCEEDED, payload: action.payload } );

            showMessage( { message: _( wording( action.payload.context, 'lineup' ) ? 'Zur Aufstellung hinzugefügt' : 'Zum Roster hinzugefügt' ) + ': ' + added.join( ', ' ) } );

        } else {

            yield loadingError( ADDING_PLAYERS_TO_ROSTER_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( ADDING_PLAYERS_TO_ROSTER_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* confirmGameReportReferee( action ) {

    const err = _( 'Game Report Referee konnte nicht unterschrieben werden.' );

    try {

        const response = yield call( Api.confirmGameReportReferee, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: CONFIRMING_GAME_REPORT_REFEREE_SUCCEEDED, payload: { ...action.payload } } );

            showMessage( { message: _( 'Game Report Referee unterschrieben.' ) } );

        } else {

            yield loadingError( CONFIRMING_GAME_REPORT_REFEREE_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( CONFIRMING_GAME_REPORT_REFEREE_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* confirmRosterPlayers( action ) {

    const err = _( wording( action.payload.context, 'lineup' ) ? 'Aufstellungen konnten nicht bestätigt werden.' : 'Roster konnten nicht bestätigt werden.' );

    try {

        const response = yield call( Api.confirmRosterPlayers, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: CONFIRMING_ROSTER_PLAYERS_SUCCEEDED, payload: { ...action.payload, data: response.data } } );

            showMessage( { message: _( wording( action.payload.context, 'lineup' ) ? 'Aufstellungen bestätigt. Spieler aufgestellt:' : 'Roster bestätigt. Spieler im Roster:' ) + ' ' + response.data.confirmedPlayers } );

        } else {

            yield loadingError( CONFIRMING_ROSTER_PLAYERS_FAILED, null, null, err );

        }

    } catch( e ) {

        yield loadingError( CONFIRMING_ROSTER_PLAYERS_FAILED, null, null, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* editRosterPlayer( action ) {

    const err = _( 'Daten konnten nicht geändert werden.' );

    try {

        const response = yield call( Api.editRosterPlayer, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: EDITING_ROSTER_PLAYER_SUCCEEDED, payload: action.payload } );

            showMessage( { message: _( 'Daten wurden geändert.' ) } );

        } else {

            yield loadingError( EDITING_ROSTER_PLAYER_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( EDITING_ROSTER_PLAYER_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* editRosterPlayers( action ) {

    const err = _( 'Daten konnten nicht gespeichert werden.' );

    try {

        const response = yield call( Api.editRosterPlayers, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: EDITING_ROSTER_PLAYERS_SUCCEEDED, payload: action.payload } );

            showMessage( { message: _( 'Daten wurden gespeichert.' ) } );

        } else {

            yield loadingError( EDITING_ROSTER_PLAYERS_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( EDITING_ROSTER_PLAYERS_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadEligiblePlayers( action ) {

    const { teamId } = action.payload;
    const err        = _( 'Spieler konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getEligiblePlayers, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_ELIGIBLE_PLAYERS_SUCCEEDED, payload: { eligibles: response.data, teamId } } );

        } else {

            yield loadingError( LOADING_ELIGIBLE_PLAYERS_FAILED, null, { teamId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_ELIGIBLE_PLAYERS_FAILED, null, { teamId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadEligibleTeamOfficials( action ) {

    const { teamId } = action.payload;
    const err        = _( 'Team-Offizielle konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getEligibleTeamOfficials, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED, payload: { eligibles: response.data, teamId } } );

        } else {

            yield loadingError( LOADING_ELIGIBLE_TEAM_OFFICIALS_FAILED, null, { teamId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_ELIGIBLE_TEAM_OFFICIALS_FAILED, null, { teamId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadExtendedEligiblePlayers( action ) {

    const { teamId } = action.payload;
    const err        = _( 'Spieler konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getExtendedEligiblePlayers, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_EXTENDED_ELIGIBLE_PLAYERS_SUCCEEDED, payload: { eligibles: response.data, teamId } } );

        } else {

            yield loadingError( LOADING_EXTENDED_ELIGIBLE_PLAYERS_FAILED, null, { teamId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_EXTENDED_ELIGIBLE_PLAYERS_FAILED, null, { teamId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadExtendedEligibleTeamOfficials( action ) {

    const { teamId } = action.payload;
    const err        = _( 'Team-Offizielle konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getExtendedEligibleTeamOfficials, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED, payload: { eligibles: response.data, teamId } } );

        } else {

            yield loadingError( LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_FAILED, null, { teamId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_FAILED, null, { teamId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadGameReportReferee( action ) {

    const { gameId } = action.payload;
    const err        = _( 'Game Report Referee konnte nicht geladen werden.' );

    try {

        const response = yield call( Api.getGameReportRefere, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_GAME_REPORT_REFEREE_SUCCEEDED, payload: { data: response.data || {}, gameId } } );

        } else {

            yield loadingError( LOADING_GAME_REPORT_REFEREE_FAILED, null, { gameId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_GAME_REPORT_REFEREE_FAILED, null, { gameId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadGames( action ) {

    const err = _( 'Spiele konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getGames, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_GAMES_SUCCEEDED, payload: { games: response.data } } );

        } else {

            yield loadingError( LOADING_GAMES_FAILED, null, null, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_GAMES_FAILED, null, null, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadReferees( action ) {

    const { gameId } = action.payload;
    const err        = _( 'Referees konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getReferees, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_REFEREES_SUCCEEDED, payload: { referees: response.data, gameId } } );

        } else {

            yield loadingError( LOADING_REFEREES_FAILED, null, { gameId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_REFEREES_FAILED, null, { gameId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadRosters( action ) {

    const { gameId } = action.payload;
    const err        = _( wording( action.payload.context, 'lineup' ) ? 'Aufstellungen konnten nicht geladen werden.' : 'Roster konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getRosters, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_ROSTERS_SUCCEEDED, payload: { rosters: response.data, gameId } } );

        } else {

            yield loadingError( LOADING_ROSTERS_FAILED, null, { gameId }, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_ROSTERS_FAILED, null, { gameId }, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadScores( action ) {

    const err = _( 'Scores konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getScores, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_SCORES_SUCCEEDED, payload: { ...action.payload, scores: response.data } } );

        } else {

            yield loadingError( LOADING_SCORES_FAILED, null, null, err );

        }

    } catch( e ) {

        console.log(e);

        yield loadingError( LOADING_SCORES_FAILED, null, null, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* loadSeasons( action ) {

    const err = _( 'Saisonen konnten nicht geladen werden.' );

    try {

        const response = yield call( Api.getSeasons, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: LOADING_SEASONS_SUCCEEDED, payload: { seasons: response.data } } );

        } else {

            yield loadingError( LOADING_SEASONS_FAILED, null, null, err );

        }

    } catch( e ) {

        yield loadingError( LOADING_SEASONS_FAILED, null, null, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* overwriteGameReportReferee( action ) {

    const err = _( 'Game Report Referee konnte nicht überschrieben werden.' );

    try {

        const response = yield call( Api.overwriteGameReportReferee, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: OVERWRITING_GAME_REPORT_REFEREE_SUCCEEDED, payload: { ...action.payload } } );

        } else {

            yield loadingError( OVERWRITING_GAME_REPORT_REFEREE_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( OVERWRITING_GAME_REPORT_REFEREE_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* publishRoster( action ) {

    const err = _( action.payload.publish ? ( wording( action.payload.context, 'lineup' ) ? 'Aufstellung konnte nicht veröffentlicht werden.' : 'Roster konnte nicht veröffentlicht werden.' ) : ( wording( action.payload.context, 'lineup' ) ? 'Veröffentlichung der Aufstellung konnte nicht aufgehoben werden.' : 'Roster-Veröffentlichung konnte nicht aufgehoben werden.') );

    try {

        const response = yield call( Api.publishRoster, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: PUBLISHING_ROSTER_SUCCEEDED, payload: { ...action.payload } } );

            showMessage( { message: _( action.payload.publish ? ( wording( action.payload.context, 'lineup' ) ? 'Aufstellung veröffentlicht.' : 'Roster veröffentlicht.' ) : ( wording( action.payload.context, 'lineup' ) ? 'Veröffentlichung der Aufstellung aufgehoben.' : 'Roster-Veröffentlichung aufgehoben.' ) ) } );

        } else {

            yield loadingError( PUBLISHING_ROSTER_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( PUBLISHING_ROSTER_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* removeRosterPlayer( action ) {

    const err = _( action.payload.isTeamOfficial ? 'Team-Offizieller konnte nicht entfernt werden.' : 'Spieler konnte nicht entfernt werden.' );

    try {

        const response = yield call( Api.removeRosterPlayer, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: REMOVING_ROSTER_PLAYER_SUCCEEDED, payload: action.payload } );

            showMessage( { message: _( action.payload.isTeamOfficial ? 'Team-Offizieller wurde entfernt.' : 'Spieler wurde entfernt.' ) } );

        } else {

            yield loadingError( REMOVING_ROSTER_PLAYER_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( REMOVING_ROSTER_PLAYER_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* saveGameReportRefereeDraft( action ) {

    const err = _( 'Entwurf konnte nicht gespeichert werden.' );

    try {

        const response = yield call( Api.saveGameReportRefereeDraft, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: SAVING_GAME_REPORT_REFEREE_DRAFT_SUCCEEDED, payload: { ...action.payload } } );

        } else {

            yield loadingError( SAVING_GAME_REPORT_REFEREE_DRAFT_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( SAVING_GAME_REPORT_REFEREE_DRAFT_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* setRosterStatus( action ) {

    const messages = {

        lockRosters:   wording( action.payload.context, 'lineup' ) ? 'Aufstellungen wurden gesperrt. Teams können keine Spieler mehr hinzufügen oder bearbeiten. Facecheck kann durchgeführt werden.' : 'Roster wurden gesperrt. Teams können keine Spieler mehr hinzufügen oder bearbeiten. Facecheck kann durchgeführt werden.',
        readyToPlay:   'Facecheck abgeschlossen. Spiel ist Ready to Play.',
        unlockRosters: wording( action.payload.context, 'lineup' ) ? 'Aufstellungen wurden entsperrt. Teams können Spieler nun hinzufügen und bearbeiten.' : 'Roster wurden entsperrt. Teams können Spieler nun hinzufügen und bearbeiten.',
        unreadyToPlay: 'Spiel ist Unready to Play. Facecheck kann wieder durchgeführt werden.'

    };

    const errorMessages = {

        lockRosters:   wording( action.payload.context, 'lineup' ) ? 'Aufstellungen konnten nicht gesperrt werden.'  : 'Roster konnten nicht gesperrt werden.',
        readyToPlay:   'Facecheck konnte nicht abgeschlossen werden.',
        unlockRosters: wording( action.payload.context, 'lineup' ) ? 'Aufstellungen konnten nicht entsperrt werden.' : 'Roster konnten nicht entsperrt werden.',
        unreadyToPlay: 'Spiel konnte nicht auf Unready to Play gesetzt werden.'

    };

    const message      = _( ( action.payload.command in messages      ) ? messages[      action.payload.command ] : 'Rosterstatus wurde geändert.' );
    const errorMessage = _( ( action.payload.command in errorMessages ) ? errorMessages[ action.payload.command ] : 'Rosterstatus konnte nicht geändert werden.' );

    try {

        const response = yield call( Api.setRosterStatus, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: SETTING_ROSTER_STATUS_SUCCEEDED, payload: { rosterStatus: response.data, gameId: action.payload.gameId } } );

            showMessage( { message } );

        } else {

            yield loadingError( SETTING_ROSTER_STATUS_FAILED, null, null, errorMessage );

        }

    } catch( e ) {

        yield loadingError( SETTING_ROSTER_STATUS_FAILED, null, null, errorMessage );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* signGameReportReferee( action ) {

    const err = _( 'Game Report Referee konnte nicht unterschrieben werden.' );

    try {

        const response = yield call( Api.signGameReportReferee, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: SIGNING_GAME_REPORT_REFEREE_SUCCEEDED, payload: { ...action.payload } } );

            showMessage( { message: _( 'Game Report Referee unterschrieben.' ) } );

        } else {

            yield loadingError( SIGNING_GAME_REPORT_REFEREE_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( SIGNING_GAME_REPORT_REFEREE_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* signSupplementary( action ) {

    const err = _( 'Beiblatt konnte nicht unterschrieben werden.' );

    try {

        const response = yield call( Api.signSupplementary, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: SIGNING_SUPPLEMENTARY_SUCCEEDED, payload: { ...action.payload, data: response.data } } );

        } else {

            yield loadingError( SIGNING_SUPPLEMENTARY_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( SIGNING_SUPPLEMENTARY_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* takeFaceCheck( action ) {

    const err = _( 'Facecheck konnte nicht übernommen werden.' );

    try {

        const response = yield call( Api.takeFaceCheck, action.payload );

        if ( response.statusId > 0 ) {

            yield put( { type: TAKING_FACE_CHECK_SUCCEEDED, payload: { ...action.payload, data: response.data } } );

            showMessage( { message: _( 'Facecheck übernommen.' ) } );

        } else {

            yield loadingError( TAKING_FACE_CHECK_FAILED, null, action.payload, err );

        }

    } catch( e ) {

        yield loadingError( TAKING_FACE_CHECK_FAILED, null, action.payload, err );

    }

    yield put( { type: IS_LOADING, payload: { loading: false } } );

}

function* itemsSaga() {

    yield all( [
        takeLatest( ADD_PLAYERS_TO_ROSTER,                      addPlayersToRoster                ),
        takeLatest( CONFIRM_GAME_REPORT_REFEREE,                confirmGameReportReferee          ),
        takeLatest( CONFIRM_ROSTER_PLAYERS,                     confirmRosterPlayers              ),
        takeLatest( EDIT_ROSTER_PLAYER,                         editRosterPlayer                  ),
        takeLatest( EDIT_ROSTER_PLAYERS,                        editRosterPlayers                 ),
        takeLatest( ELIGIBLE_PLAYERS_REQUESTED,                 loadEligiblePlayers               ),
        takeLatest( ELIGIBLE_TEAM_OFFICIALS_REQUESTED,          loadEligibleTeamOfficials         ),
        takeLatest( EXTENDED_ELIGIBLE_PLAYERS_REQUESTED,        loadExtendedEligiblePlayers       ),
        takeLatest( EXTENDED_ELIGIBLE_TEAM_OFFICIALS_REQUESTED, loadExtendedEligibleTeamOfficials ),
        takeLatest( GAME_REPORT_REFEREE_REQUESTED,              loadGameReportReferee             ),
        takeLatest( GAMES_REQUESTED,                            loadGames                         ),
        takeLatest( OVERWRITE_GAME_REPORT_REFEREE,              overwriteGameReportReferee        ),
        takeLatest( PUBLISH_ROSTER ,                            publishRoster                     ),
        takeLatest( REMOVE_ROSTER_PLAYER,                       removeRosterPlayer                ),
        takeLatest( REFEREES_REQUESTED,                         loadReferees                      ),
        takeLatest( ROSTERS_REQUESTED,                          loadRosters                       ),
        takeLatest( SAVE_GAME_REPORT_REFEREE_DRAFT,             saveGameReportRefereeDraft        ),
        takeLatest( SCORES_REQUESTED,                           loadScores                        ),
        takeLatest( SEASONS_REQUESTED,                          loadSeasons                       ),
        takeLatest( SET_ROSTER_STATUS,                          setRosterStatus                   ),
        takeLatest( SIGN_GAME_REPORT_REFEREE,                   signGameReportReferee             ),
        takeLatest( SIGN_SUPPLEMENTARY,                         signSupplementary                 ),
        takeLatest( TAKE_FACE_CHECK,                            takeFaceCheck                     )
    ] );

}

export default itemsSaga;